<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(back='page1-1')
              | Estás en: Elige tu Crédito Hipotecario / ¿Estoy listo para cursar esta lección?
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA 1 DE 5
            v-card-text.titulo24Reg
              | Existen diferentes mitos alrededor del crédito; poder esclarecerlos es el primer paso para sacarle mayor provecho a esta poderosa herramienta financiera.
            v-card-text.parrafoDestacadoB.text-center  Dada la siguiente afirmación, selecciona la respuesta que consideres correcta.
            v-card.questionCard(justify-center, flat)
              v-card-text.titulo18Book.text-center
                | El crédito es una opción de financiamiento que te permite adquirir bienes y servicios, pero es una herramienta cara.
              v-layout.py-0.my-0(row, justify-center)
                v-flex(xs8, sm6, md4, offset-xs1, justify-center)
                  v-radio-group(v-model='respuesta ', row)
                    div(v-if='sent && (respuesta==true) ')
                      v-icon(size='15px', color='red ') fas fa-times
                    v-radio.pt-0.px-4(color='primary ', :label='`Cierto` ', :value='true ')
                    div(v-if='sent && (respuesta==false) ')
                      v-icon(size='15px', color='green') fas fa-check
                    v-radio.pt-0.px-4(color='primary ', :label='`Falso` ', :value='false ')
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false ')
                  v-btn.btn(color='secondary ', v-bind:class='responseIsNone ', :disabled="respuesta=='none' ", @click='sendResult() ')
                    | Enviar
                div(v-if='sent ')
                  v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                    | Ver Retroalimentación
                  v-dialog(v-model='dialog ', persistent, max-width='930px ')
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          div(v-if='sent && (respuesta==false) ')
                            v-layout(v-if='dialog ')
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png ')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Bien!
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5
                                  | Los costos financieros de un crédito bien administrado pueden mantenerse en niveles adecuados. Quien sabe manejar bien sus créditos y aprovechar el financiamiento que otorgan, ven al crédito como una herramienta eficaz
                                  | que les permite allegarse de bienes y servicios.
                                p.text-sm-left.px-5
                                  b
                                    | En este sentido, es falsa la idea de que un crédito es necesariamente una herramienta cara, ¡tu respuesta es correcta!
                          div(v-if='sent && (respuesta==true) ')
                            v-layout(v-if='dialog ')
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoStop.png ')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Tu respuesta puede mejorar!
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5
                                  | Cuando una persona no administra bien su crédito incurre en cargos adicionales; por ejemplo, en cargos por falta de pago, que se aplican según las condiciones pactadas de inicio en el contrato.
                                p.text-sm-left.px-5
                                  | La clave para hacer del crédito una herramienta financiera eficaz y no “cara”, es una buena administración dentro de las condiciones normales del crédito.
                                p.text-sm-left.px-5
                                  | Con base en lo anterior ¿reconsiderarías la idea de que un crédito es una herramienta necesariamente cara?
                          v-btn.btn.dialog_btn(color='accent ', @click.prevent="nextPage( 'page1-3') ")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      dialog: false,
      correcta: false,
      respuesta: 'none',
      sent: false,
      resultado: 0,
    }
  },
  methods: {
    sendResult() {
      if (this.correcta == this.respuesta) {
        this.resultado = 1;
      }
      this.sent = true;
      eventBus.$emit('send_result', this.resultado);
      eventBus.$emit('send_suspend_data', this.respuesta);

    },
    nextPage(page) {
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      eventBus.$emit('last_page', page);
    }
  },
  created() {
    if ('suspend_data'in this.$parent) {
      if (this.$parent.currentPage in this.$parent.suspend_data) {
        this.respuesta = this.$parent.suspend_data[this.$parent.currentPage];
        this.sendResult();
      }
    }
  },
  computed: {
    responseIsNone() {
      return {
        'btn-primary': this.respuesta != 'none',
        'btn-secondary': this.respuesta == 'none'
      }
    }
  }
};
</script>
